<template>
  <ul :class="`${listClasses} toggling-dropdown`">
    <li class="dropdown-header">Job details</li>
    <ReportColumnToggle
      query-property="show_job_title"
      :update-search="false"
    >
      Job title
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_job_type"
      :update-search="false"
    >
      Job type
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_department"
      :update-search="false"
    >
      Department
    </ReportColumnToggle>

    <li class="dropdown-header">Hiring details</li>
    <ReportColumnToggle
      query-property="show_employment_type"
      :update-search="false"
    >
      Employment type
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_workplace_model"
      :update-search="false"
    >
      In-office / Remote
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_employed_through"
      :update-search="false"
    >
      Employed through
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_employed_through_name"
      :update-search="false"
    >
      Name of Vendor/EOR/Subsidiary
    </ReportColumnToggle>

    <li class="dropdown-header">Accounting</li>
    <ReportColumnToggle
      query-property="show_tax_id"
      :update-search="false"
    >
      Tax ID number
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_tax_type"
      :update-search="false"
    >
      Tax type
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_account_code"
      :update-search="false"
    >
      Account code
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_currency"
      :update-search="false"
    >
      Currency
    </ReportColumnToggle>

    <li class="dropdown-header">Timeline</li>
    <ReportColumnToggle
      query-property="show_start_date"
      :update-search="false"
    >
      Start date
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_end_date"
      :update-search="false"
    >
      End date
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_termination_reason"
      :update-search="false"
    >
      Termination reason
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_employment_comment"
      :update-search="false"
    >
      Employment comment
    </ReportColumnToggle>
  </ul>
</template>
<script>
export default {
  name: 'ReportShowMemberEmploymentColumnToggleFields',
  props: {
    listClasses: {
      type: String,
      default: 'dropdown-menu dropdown-submenu-left reports-dropdown',
    },
  },
};
</script>
